import { HttpHandler } from '../../HttpHandler';
import { environment } from '../../../enviroments';

export const getAccessToken = async (userID: string, consultationID: string, channelID: string) => {
  const { data } = await HttpHandler({
    url: `${environment.AGORA_URL}/access-token/${userID}/${consultationID}?channelName=${channelID}&expireTime=${10800}`,
    method: 'GET',
  });

  return data.token;
};

export const getRtmAccessToken = async (userID: string) => {
  const { data } = await HttpHandler({
    url: `${environment.AGORA_URL}/rtm-token/${userID}/`,
    method: 'GET',
  });

  return data.token;
};
